// extracted by mini-css-extract-plugin
export default {"container":"vcWClQ","panel":"lg6ygT"};